/**
 * The worker's "all stops done" moment (RD-DASH-011): the check draws in ONCE PER DAY per user, the first
 * time the all-done state renders on this device — not tied to the sign-in entrance window, so a worker who
 * comes back to the dashboard after logging the last visit still sees it. Device-local flag
 * `cvx.allDoneSeen:<userId>:<tenant-today yyyy-mm-dd>`; only today's key is kept. Every storage access is
 * guarded: when storage throws, the answer is "do not play" (the static drawn check shows).
 * Cleared at sign-out with the other per-user device state (clearPerUserDeviceState).
 */
export const ALL_DONE_SEEN_PREFIX = 'cvx.allDoneSeen:';

/** True exactly once per user per tenant day (and marks it seen); false on any repeat or storage failure. */
export function claimAllDoneMoment(userId, ymd) {
  if (!userId || !ymd) return false;
  try {
    const key = `${ALL_DONE_SEEN_PREFIX}${userId}:${ymd}`;
    if (window.localStorage.getItem(key)) return false;
    window.localStorage.setItem(key, '1');
    const old = [];
    for (let i = 0; i < window.localStorage.length; i += 1) {
      const k = window.localStorage.key(i);
      if (k && k.startsWith(ALL_DONE_SEEN_PREFIX) && k !== key) old.push(k);
    }
    old.forEach((k) => window.localStorage.removeItem(k));
    return true;
  } catch {
    return false;
  }
}
